export class CollateralDisplayInfo {
	// public 変数 -----------------------------------------------------------
	public collateralKey: 			string = null;	// 担保種目キー
	public displayCollateralName: 	string = null;	// 補償表示名
	public collateralShortName:		string = null;	// 補償略称名
	public collateralDescription: 	string = null;	// 補償説明
	public orderNo: 				number = 0;		// 表示順序
	public coverageAmount:			string = null;
	// ------------------------------------------------------------------------
}